<script>
import { fade } from 'svelte/transition'
import HeaderVideo from '../videos/HeaderVideo.svelte'

let showBalsam = false
setInterval( () => { showBalsam = !showBalsam }, 1000 * 2)
</script>

<style>
@keyframes bottle{
    from{ opacity:0; }
    to{ opacity:1; }
}

.is-flexified {
    display: flex;
    justify-content: center;
    align-items: center;
}

h1 { font-size: 4rem; width: 50%;
    padding: 0 1rem;
    min-width: 300px;
}

span {
    display: none;
}

span.is-active {
    display: inline-block;
}

.under {
    display: none;
    width: 100%;
    height:80px;
}
.under span {
    width: 40%;
}

.logo{ width:150px; top:0px; right:0px; cursor:pointer; }

@media (max-width: 768px){
    h1 {
        font-size: 2.25rem;
        line-height: 1;
    }
    .is-flexified {
        flex-wrap: wrap;
    }
    .is-flexified .by-side {
        display: none;
    }

    .is-flexified .under {
        margin-top: 15px;
        margin-bottom: 15px;
        display: block;
    }

    span.is-active {
        display: inline;
    }

    .container img {
        max-width: 45%;
    }

    .container--logo {
        margin-top: 0 !important;
    }
    .hero-body{ margin-top:0px; padding-top:0px; }
}
a{ border:none; }
</style>

<section class="hero is-fullheight" style="overflow:hidden; position:relative; background: radial-gradient(circle, var(--bg-color) 0%, var(--bg-color) 100%);">
    <div class="hero-head">
        <div class="container container--logo is-clearfix has-text-centered" style="margin-top:30px; position:relative; z-index:10;">
            <a href="http://www.rigablack.com/" target="_blank">
                <img alt="Logo" src="./res/logo.svg" style="position:absolute;" class="logo is-hidden-mobile" />
                <img alt="Logo" src="./res/logo.svg" style="margin-bottom:30px;" class="logo is-hidden-desktop is-hidden-tablet" />
            </a>
        </div>
    </div>
    <div class="hero-body">
        <HeaderVideo />

        <div class="container container--blackflame ">
            <div class="is-clearfix has-text-centered is-flexified">
                <h1 class="by-side">Black</h1>

                
                <img alt="Riga Black Balsam" src="./res/bottle.png" />
                

                <h1 class="by-side">
                    <span class:is-active={showBalsam} >Balsam</span>
                    <span class:is-active={!showBalsam} >Flame</span>
                </h1>
                <h1 class="under">
                    <div><span class="is-active">Black</span></div>
                    <span class:is-active={showBalsam} >Balsam</span><span class:is-active={!showBalsam} >Flame</span>
                </h1>
            </div>
            <div class="is-clearfix has-text-centered">
                <img alt="Scroll down" src="./res/down.svg" class="animated faa-vertical" />
            </div>
        </div>
    </div>
</section>
